import {Vue, MsgBox} from '../../app.vues';
import {Utils} from '../../app.base';

import SwbServcWorkVoucherDetail from './ServcWorkVoucherDetail';
import SwbServcWorkVoucherRecList from './ServcWorkVoucherRecList';
// -------- 基于设备 [查看维保记录] --------
import SwbDeviceRepairRec from './DeviceRepairRec';
// 设备检验信息
import SwbDevcMaintInfo from './DevcMaintInfo';
import SwbDevcInspectInfo from './DevcInspectInfo';
import SwbServcWorkStaffQualiList from './ServcWorkStaffQualiList';
import SwbServcWorkVoucherDsAssignServicerSelect from '../easyReport/ServcWorkVoucherDsAssignServicerSelect';
import SebServcWorkAddItem from './ServcWorkAddItem'
Vue.regist(SwbServcWorkStaffQualiList);
Vue.regist(SwbServcWorkVoucherDetail);
Vue.regist(SwbServcWorkVoucherRecList);
Vue.regist(SwbDeviceRepairRec);
Vue.regist(SwbDevcMaintInfo);
Vue.regist(SwbDevcInspectInfo);
Vue.regist(SwbServcWorkVoucherDsAssignServicerSelect);
Vue.regist(SebServcWorkAddItem);

import SwbServcWorkVoucherListForSelect from './ServcWorkVoucherListForSelect';
Vue.regist(SwbServcWorkVoucherListForSelect);

// 选择工单
export function openServcWorkVoucherListForSelectDlg(dlgConfig, callback) {
    let checkedIds = dlgConfig['checkedIds'] || []; // 回显数据
    let checkBox = dlgConfig['checkBox']; // 是否多选
    let filter = dlgConfig['filter'] || null;
    //
    let theDlg = Vue.$showDialog({
        title: "服务工单 - 选择",
        width: 1200,
        height: 800,
        template: '<swb-servc-work-voucher-list-for-select :filter="filter" :checkedIds="checkedIds" :checkBox="checkBox" ref="swb_servc_work_voucher_list_for_select"></swb-servc-work-voucher-list-for-select>',
        data: {
            checkedIds: checkedIds,
            checkBox: checkBox,
            filter: filter
        },
        okClicked: function () {
            let result = this.$refs.swb_servc_work_voucher_list_for_select.getDlgResult() || {};
            if(result.type == 'info') {
                //
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

export function openWorkVoucherDetailDlg(voucherId, voucherNo) {
    //
    Vue.$showDialog({
        title: '服务工单 - 详情',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-detail :voucherId = "voucherId" :voucherNo="voucherNo" ref="swb_servc_work_voucher_detail"></swb-servc-work-voucher-detail>' +
        '</div>',
        data: {
            voucherId: voucherId,
            voucherNo: voucherNo
        }
    });
}

import SwbServcWorkVoucherPdf from './ServcWorkVoucherPdf'
Vue.regist(SwbServcWorkVoucherPdf);

export function openWorkVoucherPdfDlg(voucherId) {
    Vue.$showDialog({
        title: '服务工单 - 打印',
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-servc-work-voucher-pdf :voucherId = "voucherId" ref="swb_servc_work_voucher_pdf"></swb-servc-work-voucher-pdf>',
        data: {
            voucherId: voucherId
        }
    });
}

export function openWorkVoucherRecsDlg(voucherId, callback) {
    //
    Vue.$showDialog({
        title: '服务工单 - 操作记录',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-rec-list :voucherId = "voucherId" ref="swb_servc_work_voucher_rec_list"></swb-servc-work-voucher-rec-list>' +
        '</div>',
        data: {
            voucherId: null
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}

/*
 showRepairRec: 显示维修记录
 showMaintPlan: 显示保养记录
 */
export function openDeviceRepairRecDlg(tmpNo, showRepairRec, showMaintPlan, maintPlanId, servcType) {
    showRepairRec = Utils.isNoB(showRepairRec) ? true : Utils.isTrue(showRepairRec);
    showMaintPlan = Utils.isNoB(showMaintPlan) ? true : Utils.isTrue(showMaintPlan);
    let title = "维保记录";
    if (servcType != null) {
        if (servcType == 0 || servcType == -1) {
            title = "维修记录";
        } else if (servcType == 1) {
            title = "保养记录";
        } else if (servcType == 2) {
            title = "安装记录";
        } else if (servcType == 6) {
            title = "检验记录";
        }
    }
    Vue.$showDialog({
        title: title,
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-device-repair-rec-info :hiddenTree="true" :tmpNo = "tmpNo" :showRepairRec="showRepairRec" :showMaintPlan="showMaintPlan" :maintPlanId="maintPlanId" :servcType="servcType" ref="swb_device_repair_rec_info"></swb-device-repair-rec-info>',
        data: {
            tmpNo: tmpNo,
            showRepairRec: showRepairRec,
            showMaintPlan: showMaintPlan,
            maintPlanId: maintPlanId,
            servcType: servcType
        },
        okClicked: function () {
        }
    });
}

export function openDevcMaintInfoDlg(workVoucherId) {
    Vue.$showDialog({
        title: '设备保养信息 - 详情',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-maint-info :workVoucherId = "workVoucherId" ref="swb_devc_maint_info"></swb-devc-inspect-info>',
        data: {
            workVoucherId: workVoucherId
        },
        okClicked: function () {
        },
    });
}

export function openDevcInspectInfoDlg(workVoucherId) {
    Vue.$showDialog({
        title: '设备检验信息 - 详情',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-devc-inspect-info :workVoucherId = "workVoucherId" ref="swb_servc_work_voucher_detail"></swb-devc-inspect-info>',
        data: {
            workVoucherId: workVoucherId
        },
        okClicked: function () {
        },
    });
}

/*
 检验记录
 */
export function openInspectRecDlg(inspectPlanId, planType) {
    Vue.$showDialog({
        title: '检验记录',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-device-inspect-rec-info :height="500" :hiddenTree="true" :inspectPlanId="inspectPlanId" :planType="planType" ref="swb_device_inspect_rec_info"></swb-device-inspect-rec-info>',
        data: {
            inspectPlanId: inspectPlanId,
            planType: planType
        },
        okClicked: function () {
        }
    });
}

export function openServcWorkStaffQualiDlg(voucherId) {
    Vue.$showDialog({
        title: '工单人员要求资质',
        width: 800,
        height: 600,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-servc-work-staff-quali-list :voucherId="voucherId"></swb-servc-work-staff-quali-list>',
        data: {
            voucherId: voucherId
        },
        okClicked: function () {
        }
    });
}

export function openServicerSelectComnDlg(params, callback) {
    let showDevice = params.showDevice || false;
    let showDevcgroup = params.showDevcgroup || false;
    let showComnRepair = params.showComnRepair || false;
    let showBizRel = params.showBizRel || false;
    //
    let deviceId = params.deviceId || null;
    let servcType = params.servcType;
    let repairId = params.repairId || null;
    let theDlg = Vue.$showDialog({
        title: '服务商 - 选择',
        width: 1200,
        height: 750,
        okVisible: false,
        showCloseBtn: true,
        template: '<div>' +
        '<swb-servc-work-voucher-ds-assign-servicer-select :showDevice="showDevice" :showDevcgroup="showDevcgroup" :showComnRepair="showComnRepair" :showBizRel="showBizRel" :deviceId="deviceId" :servcType="servcType"' +
        ':repairId="repairId" :assign="assign"></swb-servc-work-voucher-ds-assign-servicer-select> ' +
        '</div>',
        data: {
            showDevice: showDevice,
            showDevcgroup: showDevcgroup,
            showComnRepair: showComnRepair,
            showBizRel: showBizRel,
            deviceId: deviceId,
            servcType: servcType,
            repairId: repairId
        },
        methods: {
            assign(servicer){
                callback(servicer);
                theDlg.close();
            }
        }
    });
}
// 维保查看
export function openServcWorkAddItemDlg(voucherId, callback) {
    //
    Vue.$showDialog({
        title: '维修单 - 查看',
        width: 1100,
        height: 700,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-add-item-list :id = "voucherId" ref="swb_servc_work_voucher_rec_list"></swb-servc-work-add-item-list>' +
        '</div>',
        data: {
            voucherId: null
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}

import SwbServcWorkVoucherDlgtList from './ServcWorkVoucherDlgtList'
Vue.regist(SwbServcWorkVoucherDlgtList);
// 维保查看
export function openServcWorkVoucherDlgtdDlg(voucherId, parentThis, title, slaveFlag, expiatory) {
    Vue.$showDialog({
        title: title,
        width: -200,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-servc-work-voucher-dlgt-list :masterId="voucherId" :slaveFlag="slaveFlag" :expiatory="expiatory" :parentThis="parentThis" ref="swb_servc_work_voucher_dlgt_list"></swb-servc-work-voucher-dlgt-list>' +
        '</div>',
        data: {
            voucherId: null,
            parentThis: parentThis,
            slaveFlag: slaveFlag,
            expiatory: expiatory
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
                this.voucherId = voucherId || null;
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/workVoucher/showDetailDlg.js
// module id = 71
// module chunks = 0